import React,  { Component } from 'react';
import "./index.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopyright } from '@fortawesome/free-regular-svg-icons';

const Footer = () => (
  <FooterClass />
);

class FooterClass extends Component {

	getYear = () => {
		return new Date().getFullYear()
	}

	render() {
		return (
			<footer className="footer-glass">
				<div className="footer-content">
					<FontAwesomeIcon icon={faCopyright} className="footer-icon" />
					Copyright {this.getYear()} The Assurance Group, Inc.
				</div>
			</footer>
		);
	}
}



export default Footer;